import { render } from "./AddBooking.vue?vue&type=template&id=d0c858fe&ts=true"
import script from "./AddBooking.vue?vue&type=script&lang=ts"
export * from "./AddBooking.vue?vue&type=script&lang=ts"

import "./AddBooking.vue?vue&type=style&index=0&id=d0c858fe&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/Zalo_YHCT/ZaloOA_CLS_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__